export default [
  {
    name: 'Document',
    value: 'documents'
  },
  {
    name: 'Sale',
    value: 'merchandise'
  },
  {
    name: 'Commercial sample',
    value: 'sample'
  },
  {
    name: 'Returned goods',
    value: 'returned_goods'
  },
  {
    name: 'Gift',
    value: 'gift'
  },
  {
    name: 'Other (specity)',
    value: 'other'
  }
]